import '@slightlyoff/lite-vimeo';
import { createApp } from 'vue';
import HeaderComponent from './components/HeaderComponent.vue';
import CareerFilter from './components/CareerFilter.vue';



// Vue component
const App = {
    data() {
      return {
        message: 'Hello Vue 3!'
      };
    },
    components: {
        HeaderComponent,
        CareerFilter
    }
  };

// Vue component
// const App = createApp({
//     components: {
//         Header
//     },
//     data() {
//         return {
//             message: 'Hello Vue 3!'
//         };
//     }
// });


// disable controlls on lite-vimeo
document.addEventListener('DOMContentLoaded', function () {

    // createApp(App).mount('#app');
    // Mount Vue app
    const app = createApp(App);
    app.mount('#app');

    // Enable full-screen for lite-vimeo
    const liteVimeos = document.querySelectorAll('lite-vimeo');
    liteVimeos.forEach(liteVimeo => {
        liteVimeo.addEventListener('loaded', function () {
            const iframe = liteVimeo.shadowRoot.querySelector('iframe');
            if (iframe) {
                // Set the required attributes for full screen
                iframe.setAttribute('allowfullscreen', 'true');
                iframe.setAttribute('mozallowfullscreen', 'true');
                iframe.setAttribute('webkitallowfullscreen', 'true');
            }
        });
    });

    var contentBlocks = document.querySelectorAll('.content-block');
    if (contentBlocks) {
        // check if any of the contentBlocks children div  has a inline style , if so remove it
            contentBlocks.forEach(function (contentBlock) {
                var divs = contentBlock.querySelectorAll('div');
                if (divs) {
                    divs.forEach(function (div) {
                        if (div.hasAttribute('style')) {
                            div.removeAttribute('style');
                        }
                    });
                }
            }
        );
    }
    




});
